export default function Logo() {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2.5"
        width="36"
        height="36"
        rx="18"
        stroke="url(#paint0_angular_703_719)"
        strokeWidth="4"
      />
      <path
        d="M5.62502 13.9652C5.62502 13.9652 11.4767 19.2002 13.5713 31.7321"
        stroke="url(#paint1_linear_703_719)"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M17.1297 11.5882C19.9882 24.254 13.5712 31.7321 13.5712 31.7321"
        stroke="url(#paint2_linear_703_719)"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M17.2843 11.7408C17.2843 11.7408 25.2307 16.5404 25.2307 29.5077"
        stroke="url(#paint3_linear_703_719)"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M29.5261 5.19153C32.3878 19.955 25.2307 29.5077 25.2307 29.5077"
        stroke="url(#paint4_linear_703_719)"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <defs>
        <radialGradient
          id="paint0_angular_703_719"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20 20.5) rotate(90) scale(20)"
        >
          <stop stopColor="#8CE8E3" />
          <stop offset="0.40625" stopColor="#015FA6" />
          <stop offset="0.71875" stopColor="#2C89D9" />
          <stop offset="1" stopColor="#8CE8E3" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_703_719"
          x1="12.8034"
          y1="31.737"
          x2="5.62503"
          y2="13.9652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0078D4" />
          <stop offset="1" stopColor="#005EA4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_703_719"
          x1="12.8033"
          y1="31.737"
          x2="17.8416"
          y2="11.6284"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0078D4" />
          <stop offset="1" stopColor="#2B88D8" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_703_719"
          x1="24.4627"
          y1="29.5126"
          x2="17.2843"
          y2="11.7408"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55B0FF" />
          <stop offset="1" stopColor="#2B88D8" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_703_719"
          x1="24.3036"
          y1="29.5136"
          x2="30.48"
          y2="3.5879"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55B0FF" />
          <stop offset="1" stopColor="#A1FDD8" />
        </linearGradient>
      </defs>
    </svg>
  );
}
